import React from 'react'

export type RemoteControlRowProps = {
    button: React.ReactNode
    title: React.ReactNode
    status?: React.ReactNode
    remoteChargingControl?: React.ReactNode
}

export function RemoteControlRow({
    button,
    title,
    status,
    remoteChargingControl,
}: RemoteControlRowProps): React.ReactElement {
    return (
        <div className="flex justify-content-between align-items-center border-bottom-1 border-200">
            <div className="p-3">
                <span>{title}</span>
            </div>

            <div className="p-1 flex-1">{status}</div>
            <div className="p-1 sm:p-3">{remoteChargingControl}</div>
            <div className="sm:p-3 mr-2">{button}</div>
        </div>
    )
}
